"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var WixSDKProviderApi = /*#__PURE__*/function () {
  function WixSDKProviderApi(wixApi) {
    this.wixApi = wixApi;
  }
  var _proto = WixSDKProviderApi.prototype;
  _proto.getAnonymousUserId = function getAnonymousUserId() {
    return this.wixApi.Utils.getInstanceValue('aid');
  };
  _proto.getViewMode = function getViewMode() {
    return this.wixApi.Utils.getViewMode();
  };
  _proto.attachEditModeChanged = function attachEditModeChanged(callback) {
    this.wixApi.removeEventListener(this.wixApi.Events.EDIT_MODE_CHANGE, callback);
  };
  _proto.dettachEditModeChanged = function dettachEditModeChanged(callback) {
    this.wixApi.removeEventListener(this.wixApi.Events.EDIT_MODE_CHANGE, callback);
  };
  _proto.getCurrentPageId = function getCurrentPageId() {
    var _this = this;
    return new Promise(function (resolve) {
      _this.wixApi.getCurrentPageId(function (currentPageId) {
        resolve(currentPageId);
      });
    });
  };
  _proto.getSitePages = function getSitePages() {
    var _this2 = this;
    return new Promise(function (resolve) {
      _this2.wixApi.getSitePages(function (arrPages) {
        resolve(arrPages);
      });
    });
  };
  _proto.replaceSectionState = function replaceSectionState(state) {
    this.wixApi.replaceSectionState(state);
  };
  _proto.navigateToPage = function navigateToPage(pageId) {
    this.wixApi.navigateToPage(pageId);
  };
  _proto.getSiteInfo = function getSiteInfo() {
    var _this3 = this;
    return new Promise(function (resolve) {
      _this3.wixApi.getSiteInfo(function (info) {
        resolve(info);
      });
    });
  };
  _proto.getSectionUrl = function getSectionUrl(sectionId) {
    var _this4 = this;
    return new Promise(function (resolve) {
      _this4.wixApi.Utils.getSectionUrl({
        sectionId: sectionId
      }, function (data) {
        resolve(data);
      });
    });
  };
  _proto.getDashboardAppUrl = function getDashboardAppUrl() {
    var _this5 = this;
    return new Promise(function (resolve) {
      _this5.wixApi.Settings.getDashboardAppUrl(function (url) {
        resolve(url);
      });
    });
  };
  _proto.applicationLoaded = function applicationLoaded() {
    this.wixApi.Performance.applicationLoaded();
  };
  _proto.getLocale = function getLocale() {
    return this.wixApi.Utils.getLocale();
  };
  _proto.getDeviceType = function getDeviceType() {
    return this.wixApi.Utils.getDeviceType();
  };
  _proto.getBiToken = function getBiToken() {
    return this.wixApi.Utils.getInstanceValue('biToken');
  };
  _proto.isStyleChanged = function isStyleChanged(type) {
    return type === this.wixApi.Events.STYLE_PARAMS_CHANGE;
  };
  _proto.isVisualFocusEnabled = function isVisualFocusEnabled() {
    var _this6 = this;
    return new Promise(function (resolve) {
      if (_this6.wixApi && typeof _this6.wixApi.isVisualFocusEnabled === 'function') {
        try {
          _this6.wixApi.isVisualFocusEnabled(function (isEnabled) {
            resolve(isEnabled);
          });
        } catch (error) {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  };
  _proto.getColorByreference = function getColorByreference(strColor) {
    return this.wixApi.Styles.getColorByreference(strColor);
  };
  _proto.getStyleFontByReference = function getStyleFontByReference(strColor) {
    return this.wixApi.Styles.getStyleFontByReference(strColor);
  };
  _proto.getEditorFonts = function getEditorFonts() {
    return this.wixApi.Styles.getEditorFonts();
  };
  return WixSDKProviderApi;
}();
var _default = exports["default"] = WixSDKProviderApi;